<template>
	<div
		class="component c-contentstream padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class=" row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class="row  padding-t-12 padding-b-6">
			<div class="d-flex flex-wrap-wrap w-100 flex-grow-1 padding-x-6">
				<template v-for="item in contentstream_elements">
					<div
						v-if="
							item.type === 'tweet' || item.type === 'instagram'
						"
						:key="item.data.id"
						class="d-flex padding-6 width-100 bp-768:width-50 bp-1024:width-33 bp-1280:width-33 "
					>
						<div
							class="c-contentstream__item  width-100"
							:class="'c-contentstream__item--' + item.type"
						>
							<!-- instagram -->
							<div
								v-if="item.type === 'instagram'"
								class="c-contentstream__item-inner c-contentstream__item-inner--instagram"
							>
								<div
									class="c-contentstream__media-container c-contentstream__media-container--instagram"
								>
									<a
										:href="item.data.link"
										target="_blank"
										class="c-contentstream__media-link"
									>
										<img
											class="c-contentstream__media c-contentstream__media--instagram"
											:src="
												item.data.images
													.standard_resolution.url
											"
											:alt="
												item.data.caption
													? item.data.caption.text
													: 'No Instagram caption available'
											"
										/>
									</a>
								</div>
								<div
									class="c-contentstream__user c-contentstream__user--instagram d-flex align-items-center padding-24 line-height-125"
								>
									<span
										class="d-inline-block c-contentstream__user-icon sf-instagram margin-r-12 font-size-24"
									></span>
									<a
										:href="
											'http://instagram.com/' +
												item.data.user.username
										"
										class="c-contentstream__user-name c-contentstream__user-name--instagram font-weight-bold font-size-14"
										>{{ item.data.user.username }}</a
									>
								</div>
							</div>
							<!-- twitter -->
							<div
								v-if="item.type === 'tweet'"
								class="c-contentstream__item-inner c-contentstream__item-inner--twitter d-flex flex-direction-column align-items-start height-100"
							>
								<div
									class="c-contentstream__user c-contentstream__user--twitter d-flex align-items-center padding-24 line-height-125 flex-shrink-0"
								>
									<span
										class="d-inline-block c-contentstream__user-icon sf-twitter margin-r-12 font-size-24"
									></span>
									<a
										:href="
											'http://twitter.com/' +
												item.data.user.screen_name
										"
										class="c-contentstream__user-name c-contentstream__user-name--twitter font-weight-bold font-size-14"
										>@{{ item.data.user.screen_name }}</a
									>
								</div>
								<div
									class="c-contentstream__body padding-x-24 font-weight-300 line-height-175 margin-b-auto padding-b-24 flex-grow-1 flex-shrink-1"
									v-html="item.data.text"
								></div>
								<a
									v-if="item.data.media"
									:href="item.data.content_url"
									target="_blank"
									class="c-contentstream__button margin-24 flex-shrink-0  padding-x-24 padding-y-12 d-inline-block font-size-12 line-height-125 font-weight-700"
									>view media</a
								>
								<div
									class="c-contentstream__footer padding-y-16 width-100 flex-shrink-0"
								>
									<ul
										class="c-contentstream__actions reset-list w-100 d-flex align-items-center justify-content-center font-size-24 line-height-1"
									>
										<li
											class="c-contentstream__actions-item margin-x-12"
										>
											<a
												class="c-contentstream__actions-link"
												:href="
													'https://twitter.com/intent/favorite?tweet_id=' +
														item.data.id
												"
												aria-label="Favorite this tweet"
												target="_blank"
											>
												<span
													aria-hidden="true"
													class="sf-twitter-like sidearm-icon"
												></span>
											</a>
										</li>
										<li
											class="c-contentstream__actions-item margin-x-12"
										>
											<a
												class="c-contentstream__actions-link"
												:href="
													'https://twitter.com/intent/retweet?tweet_id=' +
														item.data.id
												"
												aria-label="Retweet this tweet"
												target="_blank"
											>
												<span
													aria-hidden="true"
													class="sf-twitter-retweet sidearm-icon"
												></span>
											</a>
										</li>
										<li
											class="c-contentstream__actions-item margin-x-12"
										>
											<a
												class="c-contentstream__actions-link"
												:href="
													'https://twitter.com/intent/tweet?in_reply_to=' +
														item.data.id
												"
												aria-label="Reply to this tweet"
												target="_blank"
											>
												<span
													aria-hidden="true"
													class="sf-twitter-reply sidearm-icon"
												></span>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<button
			class="s-common__button font-size-14 line-height-125 font-weight-700 margin-t-12"
			@click="load_more"
		>
			Show More
		</button>
	</div>
</template>

<script>
// Component does not appear to be used as of (10/23/2024)
import SectionBase from './SectionBase';
import Client from '@/client';
import CommonHeader from '@/components/common/CommonHeader';
import { should_use_v2_api } from '@/helpers';

export default {
	extends: SectionBase,
	name: 'SectionContentstream',
	components: {
		CommonHeader,
	},
	data: () => ({
		is_loading_more: false,
		contentstream_elements: [],
		display_types: [],
		selected_display_type: { type: 'All', vale: 'all' },
		count: 6,
	}),
	computed: {},
	watch: {
		selected_display_type() {
			this.get_content_stream();
		},
	},
	methods: {
		get_content_stream() {
			// Functionality is deprecated (content stream won't exist in newer signing days but olders one may have it).
			// Since I can't find an example of this in use for testing, this will have to be left as v1 for now.
			// Additionally, we will need to create a new v2 endpoint that accepts a signing day ID.
			if (should_use_v2_api()) {
				// To figure out what to do here
			} else {
				Client.get('/services/adaptive_components.ashx', {
					params: {
						type: 'content-stream',
						start: this.contentstream_elements.length,
						count: this.count,
						name:
							(this.selected_display_type &&
								this.selected_display_type.value) ||
							'all',
						sport_id: this.$root.signing_day.sport.id,
						mode: 'signingday',
						signingday_id: this.$root.signing_day.id,
					},
					headers: {
						'Access-Control-Allow-Origin': '*',
						'Content-type': 'application/json',
					},
				}).then(response => {
					if (response.data) {
						console.log(response.data);
						this.contentstream_elements = this.contentstream_elements.concat(
							response.data.stream,
						);
						if (this.display_types.length == 0) {
							this.display_types = response.data.types;
						}
					}

					this.is_loading_more = false;
				});
			}
		},
		filter_stream(display_type) {
			this.contentstream_elements = [];
			this.selected_display_type = display_type;
		},
		load_more() {
			this.is_loading_more = true;
			this.get_content_stream();
		},
	},
	created() {
		this.get_content_stream();
	},
};
</script>

<style scoped lang="scss">
.c-contentstream {
	&__item {
		background: $main-color;
		border: solid 1px $main-border-color;
		border-radius: 10px;
		overflow: hidden;
		position: relative;
		width: 100%;
		padding-bottom: 100%;
		&--instagram {
			background: black;
			padding-bottom: 0;
			position: relative;
			&:hover {
				.c-contentstream__media-container--instagram {
					&::before {
						opacity: 0.5;
					}
				}
			}
		}
	}
	&__item-inner {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		&--instagram {
			padding-bottom: 0;
			width: auto;
			height: auto;
			position: relative;
		}
	}

	&__body {
		overflow: auto;
		color: $main-font-color;
	}

	&__button {
		text-decoration: none;
		background: $color-primary;
		color: $text-on-primary;
		text-transform: uppercase;
		transition: 0.3s;
		&:hover,
		&:focus {
			background: $color-secondary;
			color: $text-on-secondary;
		}
	}

	&__footer {
		border-top: solid 1px $main-border-color;
	}

	&__media-container--instagram {
		width: 100%;
		padding-bottom: 100%;
		position: relative;
		overflow: hidden;
		background: black;
		&::before {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 75%;
			content: '';
			background: linear-gradient(
				180deg,
				rgba(0, 0, 0, 0) 0%,
				#000000 100%
			);
			z-index: 2;
			pointer-events: none;
			transition: 0.3s;
		}
	}
	&__media-link {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	&__media--instagram {
		position: absolute;
		top: 50%;
		left: 50%;
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		z-index: 1;
		transform: translate(-50%, -50%);
	}

	&__user {
		color: $main-font-color;
	}

	&__user--instagram {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 3;
		color: white;
		pointer-events: none;
	}
	&__user-name {
		text-decoration: none;
		color: $main-font-color;
		pointer-events: all;
		&:hover,
		&:focus {
			text-decoration: underline;
		}

		&--instagram {
			color: white;
		}
	}

	@media screen and (max-width: 767px) {
		&__item {
			padding-bottom: 0;
		}
		&__item-inner {
			height: auto;
			position: relative;
		}
		&__media-container--instagram {
			padding-bottom: 0;
		}
		&__media-link {
			position: relative;
		}
		&__media--instagram {
			position: relative;
			top: 0;
			left: 0;
			transform: none;
		}
	}
}
</style>
